import { Fieldset, Infobox, Text, TokenTextAppearance } from '@volkswagen-onehub/components-core';
import React, { ReactComponentElement } from 'react';
import { useTranslation } from 'react-i18next';
import './DataField.scss';

export default function DataField(props: Props) {
	const { jsxContent, title, property } = props;
	const { t } = useTranslation('ns1', { useSuspense: false });

	if (jsxContent) {
		return (
			<div className="remove-span-child">
				<Fieldset legend={title}>{jsxContent}</Fieldset>
			</div>
		);
	}

	if (property) {
		return (
			<div className="remove-span-child">
				<Fieldset legend={title}>
					<div translate="no">
						<Text appearance={TokenTextAppearance.bigcopy100}>{property}</Text>
					</div>
				</Fieldset>
			</div>
		);
	}

	return (
		<div className="remove-span-child">
			<Fieldset legend={title}>
				<div className="missing-attribute-info">
					<Infobox hideIcon>
						{' '}
						<Text appearance={TokenTextAppearance.copy100}>{t('dataNotAvailable')}</Text>
					</Infobox>
				</div>
			</Fieldset>
		</div>
	);
}

interface Props {
	title: string | undefined;
	property: string | undefined;
	jsxContent: ReactComponentElement<any> | undefined;
}
